import React from 'react';

/**
 * Template 7: Object + Large Serif Text
 * Dark/black bg, dramatic subject image center-right,
 * 1-3 word large white serif text upper-left.
 *
 * Inspired by: "Asbestos", "$400,000,000", "End of Rubber"
 */
export default function V_ObjectSerif({
  headline = 'Asbestos',
  subjectImage,
  bgColor = '#000000',
  accentColor = '#E53935',
}) {
  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: bgColor, fontFamily: "'Playfair Display', serif",
    }}>
      {/* Subtle radial glow behind subject */}
      <div style={{
        position: 'absolute', top: '20%', right: '15%',
        width: 500, height: 500, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 70%)',
      }} />

      {/* Subject image - center to right */}
      {subjectImage ? (
        <div style={{
          position: 'absolute', right: 60, top: '50%', transform: 'translateY(-50%)',
          width: 640, height: 560, zIndex: 1,
        }}>
          <img src={subjectImage} alt="" style={{
            width: '100%', height: '100%', objectFit: 'contain',
          }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', right: 120, top: '50%', transform: 'translateY(-50%)',
          width: 480, height: 400, background: 'rgba(255,255,255,0.05)',
          borderRadius: 12, zIndex: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 32, color: 'rgba(255,255,255,0.12)',
        }}>SUBJECT</div>
      )}

      {/* Large serif headline - upper left */}
      <h1 style={{
        position: 'absolute', top: 60, left: 70,
        margin: 0, fontSize: 120, fontWeight: 700, lineHeight: 1.05,
        color: '#FFFFFF', zIndex: 2,
        maxWidth: 700,
        textShadow: '0 4px 20px rgba(0,0,0,0.8)',
      }}>
        {headline}
      </h1>
    </div>
  );
}
